import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import './MultiSelect.scss'
import SelectField from './SelectField'

class SelectAdminTypeField extends Component {
  static defaultProps = {
    types: [],
  }

  render() {
    const { types, placeholder, multi, t } = this.props

    return (
      <SelectField
        {...this.props}
        placeholder={placeholder || `${multi ? t('Tipos Admin') : t('Tipo Admin')}`}
        options={types}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  types: [
    { id: 'super-admin', name: 'super-admin' },
    { id: 'company', name: 'company' },
    { id: 'provider', name: 'provider' },
    { id: 'PaaS', name: 'PaaS' },
  ],
})

export default compose(withTranslation(), connect(mapStateToProps))(SelectAdminTypeField)
